<div class="dynamic-field-container" [class.selected]="config?.selected">
  <div
    class="dynamic-field form-input text-align"
    [formGroup]="group"
    [hidden]="!config?.isFormBuilder && config?.options?.hidden"
  >
    <ups-dynamic-helper-label
      [config]="config"
      [dynamicService]="dynamicService"
    ></ups-dynamic-helper-label>
    <div class="job-search-container" style="position: relative">
      @if (!config?.options?.isMultiSelect) {
        <kendo-dropdownlist
          #dropdown
          class="k-no-dropdown w-100"
          [attr.name]="config.formControlName"
          [formControlName]="config.formControlName"
          [valuePrimitive]="false"
          [textField]="'DisplayName'"
          [valueField]="valueField"
          [defaultItem]="{ DisplayName: config?.placeholder }"
          [filterable]="true"
          (valueChange)="valueChangeItem($event)"
          search-ex
          [seSearchColumns]="[
            'DisplayName',
            'FacilityName',
            'Address',
            'City',
            'ParentCustomerName',
          ]"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.DisplayName === config?.placeholder"
            >
              @if (dataItem.Source !== 'Prospect') {
                <span (click)="toggleFavoriteFacility(dataItem, $event)">
                  <i
                    class="fas fa-star"
                    title="Add/Remove Favorite Facility"
                    [ngStyle]="{
                      color: dataItem.IsUserFavorite ? 'orange' : 'lightgrey',
                    }"
                  ></i>
                  &nbsp;
                </span>
              }
              <div>
                @if (dataItem.DisplayName) {
                  <span class="job-name link-style">
                    {{ dataItem.DisplayName }}
                  </span>
                }
                @if (dataItem.Source) {
                  <span
                    class="facility-source-badge"
                    [class.facility-source-badge--prospect]="
                      dataItem.Source === 'Prospect'
                    "
                  >
                    {{ dataItem.Source }}
                  </span>
                }
                @if (dataItem.ParentCustomerName) {
                  <div class="clearBoth">
                    <div style="display: inline-block">
                      {{ dataItem.ParentCustomerName }}
                    </div>
                  </div>
                }
                @if (dataItem.Address) {
                  <div class="clearBoth">
                    <div style="display: inline-block">
                      {{ dataItem.Address }}
                    </div>
                  </div>
                }
                <div class="clearBoth">
                  <div style="display: inline-block">
                    {{ dataItem.City || 'n/a' }}
                  </div>
                  <div style="display: inline-block">
                    {{ dataItem.State ? ', ' + dataItem.State : '' }}
                  </div>
                  <div style="display: inline-block">
                    {{ dataItem.Zip ? ' ' + dataItem.Zip : '' }}
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.DisplayName">
                <span class="job-name">{{ dataItem.DisplayName }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-dropdownlist>
      }
      @if (config?.options?.isMultiSelect) {
        <kendo-multiselect
          upsKeepSelectionOnEsc
          [attr.name]="config.formControlName"
          [formControlName]="config.formControlName"
          class="k-no-dropdown w-100"
          [valuePrimitive]="false"
          [textField]="'DisplayName'"
          [valueField]="valueField"
          [placeholder]="config?.placeholder"
          [filterable]="true"
          (valueChange)="multiSelectValueChange($event)"
          search-ex
          [seSearchColumns]="[
            'DisplayName',
            'FacilityName',
            'Address',
            'City',
            'ParentCustomerName',
          ]"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
        >
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.DisplayName === config?.placeholder"
            >
              @if (dataItem.Source !== 'Prospect') {
                <span (click)="toggleFavoriteFacility(dataItem, $event)">
                  <i
                    class="fas fa-star"
                    title="Add/Remove Favorite Facility"
                    [ngStyle]="{
                      color: dataItem.IsUserFavorite ? 'orange' : 'lightgrey',
                    }"
                  ></i>
                  &nbsp;
                </span>
              }
              <div>
                @if (dataItem.DisplayName) {
                  <span class="job-name link-style">
                    {{ dataItem.DisplayName }}
                  </span>
                }
                @if (dataItem.Source) {
                  <span
                    class="facility-source-badge"
                    [class.facility-source-badge--prospect]="
                      dataItem.Source === 'Prospect'
                    "
                  >
                    {{ dataItem.Source }}
                  </span>
                }
                @if (dataItem.ParentCustomerName) {
                  <div class="clearBoth">
                    <div style="display: inline-block">
                      {{ dataItem.ParentCustomerName }}
                    </div>
                  </div>
                }
                @if (dataItem.Address) {
                  <div class="clearBoth">
                    <div style="display: inline-block">
                      {{ dataItem.Address }}
                    </div>
                  </div>
                }
                <div class="clearBoth">
                  <div style="display: inline-block">
                    {{ dataItem.City || 'n/a' }}
                  </div>
                  <div style="display: inline-block">
                    {{ dataItem.State ? ', ' + dataItem.State : '' }}
                  </div>
                  <div style="display: inline-block">
                    {{ dataItem.Zip ? ' ' + dataItem.Zip : '' }}
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template kendoMultiSelectValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.DisplayName">
                <span class="job-name">{{ dataItem.DisplayName }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-multiselect>
      }
    </div>
    <ups-dynamic-search-error [show]="searchError"></ups-dynamic-search-error>
    @if (config?.isFormBuilder) {
      <div
        class="form-builder-mask"
        [class.hidden]="config?.options?.hidden"
      ></div>
    }
  </div>
  @if (config?.isFormBuilder) {
    <div class="form-builder-options">
      <i class="fas fa-times ms-3 cursor-pointer c-red" (click)="delete()"></i>
      <!-- <i class="fas fa-bars ms-3 cursor-grab"></i> -->
    </div>
  }
</div>
